export default __webpack_public_path__ + "static/color-wheel-110764b5c028e1817dce760a643c5420.png";